import * as React from "react";
import type { SVGProps } from "react";
const SvgSectionPayment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      fill="currentColor"
      d="M4.333 8.586h2.125v4.958H4.333zm4.604 0h2.125v4.958H8.937zm-6.02 6.375h14.166v2.124H2.917zm10.625-6.375h2.124v4.958h-2.124zM10 2.211 2.917 5.752v1.436h14.166V5.752z"
    />
  </svg>
);
export default SvgSectionPayment;
